module.exports = __webpack_public_path__ + "static/media/DuplicateSans-ThinItalic.091a32f3.woff2";